module.exports = __webpack_public_path__ + "static/media/espiga_villarica.4e2e85ed.png";